import { gql } from "graphql-tag"

const typeBonuses = gql`
  type BonusAgreement {
    bonusId: Int!
    runningNumber: Int
    type: String
    articleMainGroup: String
    articleGroup: String
    sku: String
    salesLevel1: Int
    bonusPercentLevel1: Float
    salesLevel2: Int
    bonusPercentLevel2: Float
    salesLevel3: Int
    bonusPercentLevel3: Float
    dateFromYYYYMM: String
    dateTillYYYYMM: String
    modificationDate: String
    customerNumber: String
  }

  type CustomerBonusAgreements {
    items: [BonusAgreement]
    page: Int
    size: Int
    total: Int
    totalPages: Int
    number: Int
  }

  input BonusFilterValues {
    field: String!
    operator: String!
    value: String!
  }

  type Query {
    customerBonusAgreements(
      customerNumber: String!
      page: Int = 0
      size: Int = 5
      sort: Sort = { orderBy: "modificationDate", direction: "desc" }
      filterValues: [BonusFilterValues]
    ): CustomerBonusAgreements
  }
`

export { typeBonuses }

export default typeBonuses
